import { useState, useEffect } from 'react'

export default function ModalCategoria({ categoria, onGuardar, onCancelar }) {
  const [nombre, setNombre] = useState('')
  const [emoji, setEmoji] = useState('📦')

  useEffect(() => {
    if (categoria) {
      setNombre(categoria.nombre)
      setEmoji(categoria.emoji || '📦')
    } else {
      setNombre('')
      setEmoji('📦')
    }
  }, [categoria])

  function handleSubmit(e) {
    e.preventDefault()
    if (!nombre.trim()) return
    onGuardar({ ...categoria, nombre: nombre.trim(), emoji })
  }

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/70 backdrop-blur-sm p-4">
      <div className="bg-tienda-surface rounded-3xl w-full max-w-sm p-6 space-y-4">
        <h3 className="text-xl font-bold text-tienda-text">
          {categoria?._id ? 'Editar categoría' : 'Nueva categoría'}
        </h3>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-tienda-muted text-sm mb-1">Emoji</label>
            <input
              type="text"
              value={emoji}
              onChange={e => setEmoji(e.target.value)}
              className="input-field text-3xl text-center"
              maxLength={2}
            />
            <p className="text-tienda-muted text-xs mt-1">Toca el campo y usa el teclado de emojis</p>
          </div>

          <div>
            <label className="block text-tienda-muted text-sm mb-1">Nombre</label>
            <input
              type="text"
              value={nombre}
              onChange={e => setNombre(e.target.value)}
              placeholder="Ej. Abarrotes"
              className="input-field"
              autoFocus
              required
            />
          </div>

          <div className="flex gap-3 pt-1">
            <button type="button" onClick={onCancelar} className="btn-ghost flex-1 text-center">
              Cancelar
            </button>
            <button type="submit" className="btn-primary flex-1 text-center">
              Guardar
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
